import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SectionComponent } from '../../components/section/section.component';
import { PlainImageSection, imageToPicture } from '../../components/plain-image/plain-image.component';
import { LinkSection, toPlainLink } from '../../types/link';
import { AspectRatio, RouterOrExternalLinkDirective } from '@knorr-bremse-portals/ngx-components';

import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { Section, SectionAttributes } from '../../../app/types/section';
import { CardComponent } from '@knorr-bremse-portals/ngx-components/components/card';
import { OverlayFigureComponent } from '@knorr-bremse-portals/ngx-components/components/overlay-figure';
import { PictureComponent } from '@knorr-bremse-portals/ngx-components/components/picture';
import { StandaloneLinkComponent } from '@knorr-bremse-portals/ngx-components/components/standalone-link';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';
import { EditorId } from '../../providers/editor-id.service';

type SplitTeaserSide = {
  headline: string;
  link: LinkSection;
  medium: PlainImageSection;
  text: string;
  editorIds?: {
    headline: EditorId;
    text: EditorId;
  };
}

type SplitStageTeaserSection = Section<
  {
    numColumns: 12;
    headline: string;
    sides: [SplitTeaserSide, SplitTeaserSide];
  } & SectionAttributes,
  [
    'numColumns',
    'headline',
  ],
  'split-stage-teaser'
>;

@Component({
  selector: 'section[app-split-stage-teaser]',
  styleUrls: ['./split-stage-teaser.component.scss'],
  templateUrl: './split-stage-teaser.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    EditorIdDirective,
    CardComponent,
    OverlayFigureComponent,
    PictureComponent,
    RouterOrExternalLinkDirective,
    StandaloneLinkComponent,
    FsButtonComponent,
],
})
export class SplitStageTeaserComponent extends SectionComponent<SplitStageTeaserSection> {

  protected imageToPicture = imageToPicture;
  protected aspectRatio = AspectRatio.Standard;
  protected toPlainLink = toPlainLink;

}
